//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { PojoSet } from 'pojo-sets';
import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import ReelId from '@models/ReelId';
import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';
import { FeatureNames } from '@bvengineering/curalate-features';

export const getAreNoCheckboxesSelectedImpl = (
  gallerySelection: PojoSet<ReelId>,
  isBazaarvoiceSyndicationSelected: boolean,
  isBazaarvoiceSyndicationEnabled: boolean,
) => {
  const selectedGalleryCount = PojoSet.size(gallerySelection);

  return (
    selectedGalleryCount === 0 &&
    (isBazaarvoiceSyndicationEnabled ? !isBazaarvoiceSyndicationSelected : true)
  );
};

export const getAreNoCheckboxesSelected = createSelector(
  (state: ICuralateStore) =>
    state.galleries.addToGalleriesModal.gallerySelection,
  (state: ICuralateStore) =>
    state.galleries.addToGalleriesModal.isBazaarvoiceSyndicationSelected,
  createHasFeatureSelector(FeatureNames.BazaarvoiceNetworkSyndicationFrontend),
  getAreNoCheckboxesSelectedImpl,
);

export default getAreNoCheckboxesSelected;
